export default __webpack_public_path__ + "static/media/incomingCall.b0ec2c22.gif";